import * as React from 'react';

interface IButtonSpinnerState {
  buttonClass: string;
  isDisabled: boolean;
  isSpinning: boolean;
}

interface IButtonSpinnerDispatch {
  onClick: () => void;
}

const ButtonSpinner: React.FC<IButtonSpinnerState & IButtonSpinnerDispatch> = ({
  onClick,
  buttonClass,
  isDisabled,
  isSpinning,
  children,
}) => {
  return (
    <button
      className={`btn ${buttonClass} btn-sm`}
      onClick={() => onClick()}
      disabled={isDisabled || isSpinning}
    >
      {isSpinning && (
        <span
          className='spinner-border spinner-border-sm mr-2'
          role='status'
          aria-hidden='true'
        ></span>
      )}
      {children}
    </button>
  );
};

export default ButtonSpinner;
